export const profile = {
communicationPrefs: {
screenTitle: "Preferencias de comunicación",
screenSubtitle: "Elija sobre qué nos comunicaremos con usted. Las notificaciones obligatorias son necesarias para que el servicio funcione de forma segura; las opcionales dependen completamente de usted.",
requiredSectionTitle: "Obligatorio",
requiredSectionHint: "Enviado por correo electrónico y/o push. Requerido para utilizar AssetWRX de forma segura.",
requiredBadge: "Obligatorio",
optionalSectionTitle: "Opcional",
optionalSectionHintLoading: "Cargando tus preferencias…",
optionalSectionHint: "Activa o desactiva cada una cuando quieras. La retirada surte efecto de inmediato y se registra en tu historial de consentimientos.",
alwaysOnBadge: "Siempre encendido",
alwaysOnHintLegit: "Siempre activado (necesario para que el servicio funcione con seguridad)",
marketingEmailTitle: "Actualizaciones de productos, consejos y promociones: correo electrónico",
marketingEmailBody: "Correos electrónicos ocasionales sobre nuevas funciones, patrones de flujo de trabajo y ofertas. Desactivado de forma predeterminada.",
marketingPushTitle: "Actualizaciones de productos, consejos y promociones: push",
marketingPushBody: "Notificaciones push para lanzamientos y ofertas importantes. Desactivado de forma predeterminada.",
analyticsTitle: "Análisis de productos",
analyticsBody: "Ayúdanos a entender cómo se usa AssetWRX para poder mejorarlo: pantallas usadas, toques y grabaciones de sesión en las que se oculta todo lo que escribes.",
crashReportingTitle: "Informes de estabilidad y fallos",
crashReportingBody: "Informes de fallos sin tus datos personales. Siempre activados, porque los necesitamos para que AssetWRX funcione.",
serviceNotifTitle: "Notificaciones del servicio",
serviceNotifBody: "Alertas de incidencias, recibos de facturación y cambios de cuenta.",
securityNotifTitle: "Notificaciones de seguridad",
securityNotifBody: "Alertas de inicio de sesión, cambios de contraseña, advertencias de actividad sospechosa.",
inspectionRemindersTitle: "Recordatorios de inspección",
inspectionRemindersBody: "Recordatorios de inspecciones programadas de su propiedad.",
confirmEmailError: "No se pudo enviar el correo electrónico de confirmación. Intentar otra vez.",
alreadySubscribed: "Ya estás suscrito.",
confirmationSent: "Revise su correo electrónico: le enviamos un enlace de confirmación. Haga clic en él dentro de las 24 horas para suscribirse.",
updatedFeedback: "{{title}} actualizado.",
saveError: "No se pudieron guardar sus preferencias. Intentar otra vez.",
pendingHint: "Pendiente: consulte su correo electrónico para ver el enlace de confirmación (válido por 24 h).",
deliveryPausedHint: "Suscripción en pausa por problemas de entrega. Desactívala y vuelve a activarla para reintentarlo.",
},
consentHistory: {
loading: "Cargando…",
errorTitle: "Error",
emptyTitle: "Aún no hay eventos de consentimiento",
emptyBody: "Una vez que acepte o cambie cualquier preferencia, aparecerá aquí.",
screenTitle: "Historial de consentimiento",
screenSubtitle: "Cada política que aceptaste y cada elección de marketing o analítica que diste o retiraste. Las entradas se guardan tal cual y no se pueden cambiar. Los ajustes de avisos del teléfono no son consentimientos y están en Preferencias.",
labelTerms: "Términos de servicio",
labelPrivacy: "Política de privacidad",
labelMarketingEmail: "Correo electrónico de marketing",
labelMarketingPush: "Notificaciones push de marketing",
labelAnalytics: "Análisis de productos",
labelCrashReporting: "Informe de fallos",
labelCookieAnalytics: "Cookies analíticas",
labelCookieMarketing: "Cookies de marketing",
labelLocationSharing: "Compartir ubicación durante el trabajo",
actionAccepted: "aceptado",
actionWithdrawn: "retirado",
actionUpdated: "actualizado",
detailSource: "Otorgado mediante",
detailReason: "Motivo",
sourcePhonePrompt: "La pregunta de analítica de la aplicación",
sourceSignup: "Registro",
sourceCookieBanner: "Banner de cookies",
sourceSignupCatchup: "Registro (anotado más tarde)",
device: {
ios: "iPhone o iPad",
android: "Dispositivo Android",
web: "Navegador web",
unknown: "Dispositivo desconocido",
},
},
exportData: {
whatYoullReceiveTitle: "Lo que recibirás",
itemProfile: "Su perfil y configuración de cuenta",
itemAssets: "Todos los activos, inspecciones y órdenes de trabajo que posee",
itemContacts: "Contactos y membresías de equipos",
itemRequests: "Solicitudes que planteó y cada mensaje sobre ellas.",
itemReports: "Informes y presupuestos compartidos con usted, con sus respuestas.",
itemConsent: "Su consentimiento completo y su historial de auditoría",
itemDeletionLog: "Entradas de registro de eliminación de cuentas (si las hay)",
itemPriorExports: "Una copia de cualquier solicitud de exportación anterior.",
footnote: "Cada enlace de descarga funciona durante 7 días y solo para ti.",
preparing: "Preparando su exportación…",
requestButton: "Solicitar exportación de mis datos",
recentRequestsTitle: "Solicitudes recientes",
loading: "Cargando…",
noExportsYet: "Aún no hay exportaciones: solicite una arriba para comenzar.",
statusQueued: "En cola",
statusProcessing: "Procesando",
statusReady: "Listo",
statusFailed: "Fallido",
statusExpired: "Caducado",
requestedAt: "Solicitado {{date}}",
linkExpires: "El enlace caduca {{date}}",
linkExpiresSoon: "Caduca en 24 horas · El enlace caduca {{date}}",
downloadButton: "Descargar",
readyFeedback: "Tu exportación está lista. Toca «Descargar» a continuación para guardarla.",
screenTitle: "Exportar mis datos",
screenSubtitle: "Puedes descargar una copia de los datos de tu cuenta de AssetWRX cuando quieras. Se entrega como un archivo de datos que otros programas pueden abrir.",
},
privacyDataHub: {
screenTitle: "Privacidad y datos",
screenSubtitle: "Descarga tus datos, elige qué te enviamos por correo o elimina tu cuenta. Cada cambio queda registrado en tu historial de consentimientos.",
expandLabel: "Abrir",
collapseLabel: "Cerrar",
itemPrivacyTitle: "Política de privacidad",
itemPrivacyBody: "Cómo recopilamos, utilizamos y protegemos sus datos.",
itemTermsTitle: "Términos de servicio",
itemTermsBody: "El acuerdo que rige su uso de AssetWRX.",
itemCookiesTitle: "Política de cookies",
itemCookiesBody: "Qué cookies y almacenamiento similar utilizamos y cómo controlarlos.",
itemSubprocessorsTitle: "Subprocesadores",
itemSubprocessorsBody: "Los terceros que contratamos para tratar datos, y dónde operan.",
itemDpaTitle: "Acuerdo de tratamiento de datos",
itemDpaBody: "Cómo tratamos tu contenido en tu nombre.",
itemMarketingTitle: "Política de consentimiento de marketing",
itemMarketingBody: "Cómo obtenemos, evidenciamos y respetamos su aceptación.",
itemExportTitle: "Exportar mis datos",
itemExportBody: "Descarga una copia de todo lo que hay en tu cuenta.",
itemCommsTitle: "Preferencias de comunicación",
itemCommsBody: "Elija qué actualizaciones y consejos opcionales recibirá y en qué canales.",
itemHistoryTitle: "Historial de consentimiento",
itemHistoryBody: "Todas las políticas que has aceptado y cada consentimiento de marketing o analítica que has otorgado o retirado.",
itemAiTitle: "Funciones de IA",
itemAiBody: "Si AssetWRX puede enviar fotos y texto a Google (Gemini) cuando usas una función de IA en este dispositivo.",
aiAllowed: "Permitido en este dispositivo. Google procesa lo que envía una función de IA y no lo usa para entrenar sus modelos.",
aiNotAllowed: "No permitido. Las funciones de IA preguntan antes de enviar nada.",
aiWithdraw: "Dejar de usar IA en este dispositivo",
aiAllow: "Permitir funciones de IA",
itemDeletionPolicyTitle: "Política de eliminación de datos",
itemDeletionPolicyBody: "Cómo funciona la eliminación, qué se conserva y el período de recuperación de 30 días.",
itemDeleteTitle: "Eliminar cuenta",
itemDeleteBody: "Elimina tu cuenta y tus datos de forma irreversible. Se aplica un plazo de recuperación de 30 días.",
},
security: {
  twoFactorSection: "Inicio de sesión en dos pasos",
  signIn: {
    cancel: "Cancelar",
    biometricOffHint: "Desactivado. Se olvida el inicio de sesión guardado en este teléfono.",
    biometricOnHint: "Activado. {{method}} inicia tu sesión en este teléfono (después de iniciar sesión una vez con tu contraseña).",
    biometricTitle: "Iniciar sesión con {{method}} en este teléfono",
    setPasswordFailed: "No se envió el enlace. Comprueba tu conexión e inténtalo de nuevo.",
    setPasswordSent: "Hemos enviado un enlace a {{email}}. Ábrelo para crear tu contraseña. Puedes seguir iniciando sesión con Google, Apple o Microsoft.",
    passwordChanged: "Tu contraseña se ha cambiado. Úsala la próxima vez que inicies sesión.",
    passwordFailed: "Tu contraseña no se cambió. Inténtalo de nuevo.",
    passwordMismatch: "Las dos contraseñas no coinciden. Escribe la misma dos veces.",
    passwordRequired: "Escribe una nueva contraseña.",
    passwordSave: "Guardar contraseña",
    passwordConfirmLabel: "Escríbela de nuevo",
    passwordNewLabel: "Nueva contraseña",
    setPassword: "Crear una contraseña",
    passwordChange: "Cambiar contraseña",
    passwordNone: "Inicias sesión con Google, Apple o Microsoft, así que aún no tienes contraseña.",
    passwordSet: "Inicias sesión con una contraseña.",
    passwordTitle: "Contraseña",
    emailSent: "Hemos enviado un enlace a tu nueva dirección, {{email}}. Ábrelo para completar el cambio. Hasta entonces seguirás iniciando sesión con {{current}}.",
    emailFailed: "No se envió el enlace. Comprueba tu conexión e inténtalo de nuevo.",
    emailTaken: "Otra cuenta ya usa esa dirección. Usa otra distinta.",
    emailSame: "Esa ya es tu dirección de correo.",
    emailInvalid: "Escribe una dirección como nombre@empresa.com.",
    emailSend: "Enviar enlace",
    emailNewHelper: "Enviamos un enlace a la nueva dirección. El cambio se hace cuando lo abres.",
    emailNewLabel: "Nueva dirección de correo",
    emailPending: "Esperando a que abras el enlace enviado a {{email}}.",
    emailChange: "Cambiar correo",
    emailTitle: "Correo electrónico",
    sectionTitle: "Cómo inicias sesión",
  },
title: "Seguridad",
removeLastWarning: "Este es su único autenticador. Se requieren dos factores, por lo que se le pedirá que vuelva a configurar uno inmediatamente.",
removeBody: "¿Quitar este autenticador? Puedes agregarlo nuevamente más tarde.",
removeTitle: "Eliminar autenticador",
cancel: "Cancelar",
remove: "Quitar",
removeFailedTitle: "No se pudo eliminar",
removeFailedBody: "Inténtelo de nuevo.",
statusOn: "El inicio de sesión de dos factores está activado",
statusOff: "El inicio de sesión de dos factores está desactivado",
statusSub: "Protege su cuenta con un código de una aplicación de autenticación (Microsoft Authenticator, Google Authenticator, Authy).",
methods: "Tus autenticadores",
loading: "Cargando…",
none: "Aún no hay autenticador configurado.",
authenticator: "Autenticador",
added: "Añadido",
removeA11y: "Eliminar autenticador",
add: "Agregar un autenticador",
addBackup: "Agregar un autenticador de respaldo",
},
diagnosticsScreen: {
  title: "Diagnóstico",
  subtitle: "Lo que soporte necesita saber. Nada de esto es secreto.",
  sectionBuild: "Compilación",
  sectionWorkspace: "Espacio de trabajo",
  sectionConnectivity: "Conectividad",
  sectionServices: "Servicios",
  appVersion: "Versión de la aplicación",
  build: "Compilación",
  commit: "Commit de Git",
  runtime: "Versión del runtime",
  updateChannel: "Canal de actualización",
  platform: "Plataforma",
  environment: "Entorno",
  backend: "Backend",
  workspace: "Espacio de trabajo",
  role: "Rol",
  plan: "Plan",
  capabilities: "Funciones activadas",
  connectivity: "Conexión",
  online: "En línea",
  offline: "Sin conexión",
  outbox: "Cambios pendientes de enviar",
  lastSync: "Último envío",
  sentry: "Informes de errores",
  sentryOn: "Activado · versión {{release}}",
  sentryOff: "Sin configurar",
  posthog: "Analítica de producto",
  posthogOn: "Activada (con consentimiento)",
  posthogOff: "Desactivada (sin consentimiento)",
  apiHealth: "Estado de la API",
  apiChecking: "Comprobando…",
  apiOk: "OK · {{latency}} ms · migraciones {{head}}",
  apiFail: "Inaccesible",
  push: "Notificaciones push",
  pushRegistered: "Registrado en el servicio push de Expo",
  pushNotRegistered: "No registrado en este dispositivo (requiere una compilación con credenciales push y permiso concedido)",
  pushUnsupported: "No disponible en esta plataforma",
  copy: "Copiar diagnóstico",
  copied: "Copiado",
  never: "Nunca",
  unknown: "Desconocido",
  personal: "Personal",
  none: "Ninguna",
  web: "Web",
},
whatsNew: {
  eyebrow: "Novedades de AssetWRX",
  gotIt: "Entendido",
  seeAll: "Ver todas las actualizaciones",
  sectionTitle: "Novedades",
  empty: "Aún no hay notas de la versión.",
  dateLine: "{{date}} · Versión {{version}}",
},
aboutScreen: {
  product: "AssetWRX {{version}}",
  title: "Acerca de",
  subtitle: "La versión de AssetWRX en este dispositivo. Cópiela cuando contacte con soporte.",
  build: "Compilación {{build}}",
  webBuild: "Web",
  runtime: "Entorno de ejecución {{runtime}}",
  channel: "Canal {{channel}}",
  environment: "Entorno {{environment}}",
  update: "Actualización {{update}}",
  copy: "Copiar",
  copied: "Copiado",
},
helpScreen: {
  contactSupportSubtitle: "Pregunta a una persona. Abre nuestra página de soporte en tu navegador.",
  contactSupportTitle: "Contactar con el soporte de AssetWRX",
subtitle: "AssetWRX te ayuda a gestionar activos, realizar inspecciones y hacer seguimiento de las órdenes de trabajo de reparación.",
coreWorkflowTitle: "Flujo de trabajo principal",
coreWorkflowBody: "• Agregar activos (vehículos, equipos, propiedad)\n• Iniciar una inspección con una lista de verificación\n• Compartir el informe para la aprobación del cliente\n• Convertir reparaciones aprobadas en órdenes de trabajo\n• Asignar órdenes de trabajo a miembros del equipo o contratistas",
toursTitle: "Recorridos guiados",
toursSubtitle: "Guías paso a paso dentro de la aplicación: registrar un activo, realizar una inspección, configurar el mantenimiento.",
openToursA11y: "Abrir los recorridos guiados",
guideTitle: "Guía del usuario",
guideSubtitle: "Guías paso a paso para cada parte de AssetWRX.",
openGuideA11y: "Abrir la guía del usuario",
},
pushNotificationPrefs: {
  productTitle: "Novedades del producto",
  productBody: "Respuestas a tus solicitudes de funciones y novedades de las ideas que has votado.",
  saveFailed: "Ese ajuste no se guardó. Comprueba tu conexión e inténtalo de nuevo.",
  permission: {
    onBody: "Elige abajo qué avisos te llegan.",
    onTitle: "Las notificaciones están activadas en este teléfono",
    openSettings: "Abrir ajustes",
    blockedBody: "Este teléfono no permite que AssetWRX envíe avisos. Actívalos en los Ajustes del teléfono y vuelve.",
    blockedTitle: "Las notificaciones están desactivadas para AssetWRX",
    askAction: "Activar notificaciones",
    askBody: "Te avisamos cuando te asignan trabajo, alguien responde o algo espera tu decisión. Tu teléfono te pedirá permiso.",
    askTitle: "Recibe avisos en este teléfono",
  },
assignmentTitle: "Asignado a mí",
assignmentBody: "Órdenes de trabajo e inspecciones asignadas a ti, invitaciones a contratistas y trabajo adjudicado.",
messageTitle: "Mensajes",
messageBody: "Respuestas sobre órdenes de trabajo, reportes compartidos con usted y sus informes Asset 360 y Site 360 cuando estén listos.",
approvalTitle: "Aprobaciones y solicitudes",
approvalBody: "Nuevas solicitudes, presupuestos enviados, finalizaciones y peticiones de acceso a informes pendientes de tu decisión.",
cardTitle: "Notificaciones push",
hintUnsupported: "Las notificaciones push se envían a la aplicación móvil AssetWRX. Estas configuraciones se aplican a su teléfono.",
hintLoading: "Cargando tu configuración…",
hintDefault: "Elige lo que llega a tu teléfono. Todo sigue apareciendo en la bandeja de entrada de la aplicación de cualquier manera.",
saveError: "No se pudo guardar: {{error}}",
quietHoursTitle: "Horas de silencio",
quietHoursBody: "No se envían notificaciones push durante este horario. Las notificaciones siguen llegando a la bandeja de entrada de la aplicación{{suffix}}.",
fromLabel: "Desde",
toLabel: "Hasta",
androidChannelNote: "Cada categoría tiene su propio canal de notificación de Android, por lo que también puedes ajustar el sonido y la prioridad de cada categoría en los ajustes del sistema.",
},
personal: {
notSet: "Sin definir",
personalMode: "Modo personal",
roleInCurrentContext: "Rol en el contexto actual",
roleUnavailable: "Rol no disponible",
languageNotSet: "Sin definir (predeterminado del espacio de trabajo, luego dispositivo)",
timezoneNotSet: "Sin definir (predeterminado del espacio de trabajo, luego dispositivo)",
languageHelper: "Dejar vacío para usar el predeterminado del espacio de trabajo, luego el idioma del dispositivo si está admitido, luego inglés (EE. UU.).",
timezoneHelper: "Dejar vacío para usar la zona del espacio de trabajo, luego la del dispositivo, luego UTC.",
effectiveLanguage: "Idioma efectivo",
effectiveTimezone: "Zona horaria efectiva",
localeMoved: "El idioma y la zona horaria están en Preferencias",
localeMovedA11y: "Abrir Preferencias para cambiar el idioma y la zona horaria",
sectionTitle: "Datos personales",
sectionSubtitle: "Nombre, contacto y biografía.",
photoTitle: "Foto de perfil",
photoSubtitle: "Tu foto aparece en el panel principal, las vistas de equipo y la actividad. Es independiente del logotipo del espacio de trabajo o de los informes.",
edit: "Editar",
fullName: "Nombre completo",
displayName: "Nombre para mostrar",
phone: "Teléfono",
language: "Idioma",
timezone: "Zona horaria",
email: "Correo electrónico",
bio: "Biografía",
shortBio: "Biografía breve",
editTitle: "Editar perfil",
fieldDisplayName: "Nombre para mostrar",
placeholderDisplayName: "Cómo quieres que aparezca tu nombre",
fieldFirstName: "Nombre",
placeholderFirstName: "Nombre",
fieldLastName: "Apellidos",
placeholderLastName: "Apellidos",
fieldJobTitle: "Puesto",
placeholderJobTitle: "Puesto",
langA11y: "Idioma",
tzA11y: "Zona horaria",
bioPlaceholder: "Breve descripción de tu perfil",
emailReadOnlyHint: "Para cambiar tu correo, ve a Cuenta → Seguridad.",
cancel: "Cancelar",
saveProfile: "Guardar perfil",
pickerLanguageTitle: "Idioma",
pickerTimezoneTitle: "Zona horaria",
searchLanguage: "Buscar idioma o código",
searchTimezone: "Buscar zona horaria",
errorInvalidPhone: "Introduce un número de teléfono válido.",
saveSuccessTitle: "Guardado",
saveSuccessBody: "Tu perfil se ha actualizado.",
saveErrorGeneric: "No se pudo guardar el perfil.",
phoneNumberLabel: "Número de teléfono",
countryCallingCodeA11y: "Prefijo internacional",
countryCallingCodeHint: "Abre la lista de países",
nationalNumberPlaceholder: "Número nacional",
nationalNumberA11y: "Número nacional",
countryRegionTitle: "País o región",
searchCountry: "Buscar país o código",
},
overview: {
  tileIndustryPacksSubtitle: "Tipos de activo, listas de comprobación y planes listos",
  tileIndustryPacksTitle: "Paquetes por sector",
  tileAssetTypesTitle: "Tipos de activo",
  tileAssetTypesSubtitle: "Tus propios tipos de activo y lugar, y los detalles que pide cada uno",
changePhoto: "Cambiar foto",
uploadPhoto: "Subir foto",
remove: "Quitar",
noJobTitle: "Aún sin puesto",
profileCompleteness: "Progreso del perfil",
memberSince: "Miembro desde",
recentMember: "Se unió recientemente",
moreSection: "Más",
moreSubtitle: "Espacio de trabajo, preferencias y sesión.",
personalSection: "Personal",
workspaceSection: "Espacio de trabajo",
sessionSection: "Sesión",
workspace: "Espacio de trabajo",
workspaceSubtitle: "Contexto, valores predeterminados e imagen de informes.",
preferences: "Preferencias",
help: "Ayuda",
securitySection: "Seguridad y privacidad",
privacyData: "Privacidad y datos",
consentHistory: "Historial de consentimiento",
exportData: "Exportar mis datos",
deleteAccount: "Eliminar cuenta",
signOut: "Cerrar sesión",
signOutTitle: "Cerrar sesión",
signOutConfirm: "¿Seguro que quieres cerrar sesión?",
signOutCancel: "Cancelar",
signOutAction: "Cerrar sesión",
signOutPendingNote: "Tu trabajo pendiente permanece en este dispositivo cuando cierras sesión. Podrás revisar la sincronización y resolver cualquier error antes de salir.",
reviewPendingWrites: "Revisar cambios pendientes de sincronizar",
signOutErrorTitle: "No se pudo finalizar la sesión",
signOutErrorBody: "Tus cambios guardados se han conservado. Inténtalo de nuevo.",
workspaceTypeMember: "Miembro",
workspaceTypeContractor: "Contratista",
workspaceTypeRecipient: "Destinatario",
teamsCount_one: "{{count}} equipo",
teamsCount_other: "{{count}} equipos",
kpiUsersLabel: "Usuarios",
kpiUsersHint: "En este espacio de trabajo",
kpiAssetsLabel: "Activos",
kpiAssetsHint: "Total del espacio de trabajo",
kpiInspectionsLabel: "Inspecciones",
kpiInspectionsHint: "Todos los registros",
kpiJobsLabel: "Órdenes de trabajo",
kpiJobsOpenHint_one: "{{count}} abierta",
kpiJobsOpenHint_many: "{{count}} abiertas",
kpiJobsOpenHint_other: "{{count}} abiertas",
kpiCreditsLabel: "Créditos de IA",
kpiCreditsHint: "Saldo disponible",
creditsUnlimited: "Ilimitado",
groupSettingsA11y_one: "{{title}}, {{count}} ajuste. {{action}}.",
groupSettingsA11y_many: "{{title}}, {{count}} ajustes. {{action}}.",
groupSettingsA11y_other: "{{title}}, {{count}} ajustes. {{action}}.",
groupExpandAction: "Expandir",
groupCollapseAction: "Contraer",
groupYouTitle: "Tú",
groupPlanTitle: "Plan y herramientas",
tileOrganizationTitle: "Organización",
tileOrganizationSubtitleAdmin: "Logotipo del espacio de trabajo, perfil de la empresa y datos legales",
tileOrganizationSubtitleMember: "Ver el logotipo del espacio de trabajo, el perfil de la empresa y los detalles legales",
tileTeamsTitle: "Equipos e invitaciones",
tileTeamsSubtitleAdmin: "Miembros del espacio de trabajo, roles e invitaciones",
tileTeamsSubtitleMember: "Ver miembros del espacio de trabajo, roles y tus invitaciones",
tileDefaultsTitle: "Valores regionales predeterminados",
tileDefaultsSubtitle: "Moneda, idioma, zona horaria y métodos para compartir",
tileBrandingTitle: "Marca de los informes",
tileBrandingSubtitleAdmin: "Logotipo para PDF y enlaces compartidos, y datos de exportación (independiente del espacio de trabajo)",
tileBrandingSubtitleMember: "Ver el logotipo para PDF y enlaces compartidos, y los datos de exportación",
tileIntegrationsTitle: "Integraciones",
tileIntegrationsSubtitle: "Conecta otros sistemas e importa datos",
tileTemplatesTitle: "Listas de verificación",
tileTemplatesSubtitle: "Modelos para inspecciones y órdenes de trabajo",
tileAiTitle: "IA",
tileAiSubtitle: "Uso, automatizaciones, auditoría",
tileAssistantActivityTitle: "Actividad del asistente",
tileAssistantActivitySubtitle: "Cambios hechos con el asistente",
tileYourPlanTitle: "Plan {{plan}}",
tileYourPlanTitleLimit_one: "Plan {{plan}} · {{owned}} de {{count}} activo",
tileYourPlanTitleLimit_many: "Plan {{plan}} · {{owned}} de {{count}} activos",
tileYourPlanTitleLimit_other: "Plan {{plan}} · {{owned}} de {{count}} activos",
tileYourPlanTitleUnknown: "Tu plan",
tileYourPlanSubtitle: "Ver los planes y lo que incluye cada uno",
tileBillingTitle: "Facturación",
tileBillingSubtitleAdmin: "Plan, créditos, facturas",
tileBillingSubtitleMember: "Ver plan y uso de crédito",
tileGuideTitle: "Guía del usuario",
tileGuideSubtitle: "Guías paso a paso para cada parte de AssetWRX",
tileProfileTitle: "Perfil",
tileProfileSubtitle: "Nombre, foto, contacto",
tilePreferencesSubtitle: "Idioma, apariencia y avisos del teléfono",
tileSecurityTitle: "Seguridad",
tileSecuritySubtitle: "Correo, contraseña y verificación en dos pasos",
tilePrivacyTitle: "Privacidad",
tilePrivacySubtitle: "Tus datos, nuestros correos, eliminar cuenta",
tileFeaturesTitle: "Funciones",
tileFeaturesSubtitle: "Qué está activado, desactivado o bloqueado en este espacio",
tileDiagnosticsTitle: "Diagnóstico",
tileDiagnosticsSubtitle: "Estado de compilación, conexión y sincronización para soporte",
tileAboutTitle: "Acerca de",
tileAboutSubtitle: "Versión y compilación",
groupAppTitle: "Aplicación",
tileHelpTitle: "Ayuda",
groupAdvancedTitle: "Avanzado",
tileNotificationsTitle: "Notificaciones",
tileNotificationsSubtitle: "Correos y avisos que recibes",
tileBrandingDefaultsTitle: "Marca y valores por defecto",
tileBrandingDefaultsSubtitle: "Organización, marca de informes, valores regionales",
tileApiExplorerTitle: "Explorador de API",
tileApiExplorerSubtitle: "Prueba la API pública con tus claves",
tileHandbookTitle: "Manual de integración",
tileHandbookSubtitle: "Guías para conectar y automatizar AssetWRX",
tileHelpSubtitle: "Cómo funciona AssetWRX y dónde obtener soporte",
teamsCount_many: "{{count}} equipos",
},
tabs: {
summary: "Resumen",
personal: "Personal",
profilePagesA11y: "Páginas de ajustes personales",
},
accountScreen: {
title: "Ajustes de la cuenta",
subtitleOverview: "Gestiona tu perfil, espacio de trabajo, facturación e integraciones.",
subtitleOverviewPersonalOnly: "Tu perfil, preferencias, seguridad y privacidad.",
subtitlePersonal: "Tu nombre, datos de contacto y foto",
subtitleWorkspace: "Perfil del espacio de trabajo, equipo, integraciones y facturación",
},
accountScope: {
areasA11y: "Áreas de ajustes de la cuenta",
userDetails: "Personal",
userDetailsHint: "Perfil, preferencias y ayuda",
userDetailsTabA11y: "Ajustes personales",
workspace: "Espacio de trabajo",
workspaceHint: "Organización, equipo y administración",
workspaceTabA11y: "Ajustes del espacio de trabajo",
},
preferences: {
title: "Preferencias",
subtitle: "Ajustes que solo se aplican a ti.",
localeTitle: "Idioma y región",
localeHint: "Cómo se te muestran las fechas, las horas y el texto. Están vinculados a tu cuenta, así que se aplican en todos los dispositivos en los que inicies sesión.",
localeLanguage: "Idioma",
localeTimezone: "Zona horaria",
localeLanguageA11y: "Cambiar idioma",
localeTimezoneA11y: "Cambiar zona horaria",
localeEffectiveLanguage: "Usando actualmente {{value}}",
localeEffectiveTimezone: "Usando actualmente {{value}}",
localeSaveError: "No se han podido guardar tu idioma y zona horaria.",
notificationsTitle: "Notificaciones",
pushNotifications: "Notificaciones push",
pushNotificationsHint: "Activa avisos y actualizaciones para revisiones de inspecciones, trabajos y recordatorios.",
haptics: "Respuesta háptica",
hapticsHint: "Una ligera vibración en la mano al completar, guardar o seleccionar algo.",
appearanceTitle: "Apariencia",
appearanceHint: "Elige si las pantallas usan superficies claras u oscuras en este dispositivo. Seguir el sistema respeta el ajuste de tu teléfono o escritorio.",
appearanceLight: "Claro",
appearanceDark: "Oscuro",
appearanceSystem: "Seguir el sistema",
densityComfy: "Cómoda",
densityComfyHint: "Más espacio",
densityCompact: "Compacta",
densityCompactHint: "Equilibrado",
densityDense: "Densa",
densityDenseHint: "Máximo contenido en pantalla",
textSizeDefault: "Predeterminado",
textSizeLarge: "Grande",
textSizeExtraLarge: "Extra grande",
privacyTitle: "Privacidad y datos",
privacyHint: "Gestiona tus datos personales y tu cuenta.",
privacyOpenA11y: "Abrir Privacidad y datos",
deleteAccount: "Eliminar cuenta",
deleteAccountHint: "Elimina permanentemente tu cuenta y tus datos personales.",
textSizeTitle: "Tamaño del texto",
textSizeHint: "Haga que el texto de la aplicación sea más fácil de leer. Esto se aplica en todas partes y funciona junto con la configuración de tamaño de texto de su dispositivo.",
textSizeA11y: "Tamaño del texto {{label}}",
densityTitle: "Densidad de visualización",
densityHint: "Cuánta información se incluye en cada pantalla. Se aplica en todas partes.",
densityA11y: "Densidad de visualización {{label}}",
privacyDataTitle: "Privacidad y datos",
privacyDataHint: "Política de privacidad, Términos, Exportación, Preferencias de comunicación, Historial de consentimiento, Eliminar cuenta",
},
deleteAccount: {
  ownerHandOver: "Transferir la propiedad",
  ownerImpact: "Eres el propietario de este espacio de trabajo y otras personas trabajan en él. Perderán el acceso cuando elimines tu cuenta. Para que lo conserven, transfiere antes la propiedad a otra persona.",
  contactSupport: "Contactar con el soporte de AssetWRX",
warningTitle: "Esto elimina tu cuenta de forma permanente",
warningBody: "Eliminar tu cuenta es irreversible. Una vez que pase el periodo de recuperación, tus datos no se podrán restaurar.",
consequencesTitle: "Qué se elimina",
consInspections: "Todas las inspecciones que creaste y sus informes",
consAssets: "Tus activos y su historial",
consMedia: "Fotos, documentos y otros archivos que subiste",
consTeams: "Tus membresías de equipo y el acceso a espacios compartidos",
consBilling: "Las suscripciones activas se cancelan y se detiene la facturación",
recoveryBody: "Los espacios de trabajo que te pertenecen se conservan {{days}} días y después se eliminan para siempre. Para pedir recuperarlos en ese plazo, contacta con el soporte de AssetWRX. Tus datos personales se eliminan al momento.",
offlineBanner: "Estás sin conexión. Conéctate a internet para eliminar tu cuenta.",
confirmLabel: "Escribe {{token}} para confirmar",
confirmHelper: "Introduce {{token}} exactamente como se muestra para habilitar el botón de eliminar.",
passwordLabel: "Confirma tu contraseña",
passwordHelper: "Necesaria si inicias sesión con contraseña. Déjala vacía si inicias sesión con Google, Apple o Microsoft.",
passwordPlaceholder: "Tu contraseña",
reauthError: "Vuelve a introducir tu contraseña para confirmar que eres tú.",
genericError: "No se pudo completar la eliminación de la cuenta. Inténtalo de nuevo.",
deleteButton: "Eliminar mi cuenta",
deletingStatus: "Eliminando tu cuenta…",
modalTitle: "¿Eliminar la cuenta de forma permanente?",
modalBody: "Esto no se puede deshacer. Tus datos personales se anonimizan ahora y los espacios de trabajo de tu propiedad exclusiva se eliminan tras el periodo de recuperación.",
modalConfirm: "Eliminar para siempre",
modalCancel: "Conservar mi cuenta",
successTitle: "Tu cuenta se está eliminando",
successBody: "Se ha cerrado tu sesión. Hemos empezado a eliminar tus datos y cancelado las suscripciones activas. ¿Has cambiado de idea? Contacta con el soporte de AssetWRX en un plazo de 30 días.",
complianceNote: "Puedes solicitar la eliminación de tu cuenta en cualquier momento desde la app, tal como exigen App Store y Google Play.",
cancel: "Cancelar",
},
featureRequests: {
  editFirst: "Editar antes",
  helpRowTitle: "Solicitar una función",
  helpRowSubtitle: "Cuéntanos qué haría AssetWRX mejor para ti.",
  myRequestsTitle: "Tus solicitudes",
  myRequestsSubtitle: "Lo que has pedido y en qué punto está.",
  myRequestsRowSubtitle_one: "{{count}} solicitud enviada",
  myRequestsRowSubtitle_many: "{{count}} solicitudes enviadas",
  myRequestsRowSubtitle_other: "{{count}} solicitudes enviadas",
  myRequestsEmpty: "Todavía no has solicitado ninguna función.",
  ideasTitle: "Ideas que estamos valorando",
  ideasSubtitle: "Vota las que quieras. Te avisaremos cuando avancen.",
  ideasRowSubtitle: "Vota lo que quieres a continuación.",
  ideasEmpty: "Ahora mismo no hay ideas en votación.",
  ideasFooter: "Las ideas de aquí las escribe el equipo de AssetWRX. Tus propias solicitudes son privadas.",
  loadFailed: "No se ha cargado. Comprueba tu conexión y desliza hacia abajo para reintentarlo.",
  sentOn: "Enviada el {{date}} · {{category}}",
  mergedNote: "Alguien pidió lo mismo, así que hemos unido tu solicitud a la suya. Te avisaremos cuando avance.",
  replyFromTeam: "Respuesta del equipo de AssetWRX",
  seeWhatsNew: "Ver novedades: {{title}}",
  onIdeasBoard: "Verla en las ideas",
  vote: "Lo quiero",
  voted: "Votada",
  voteA11y: "Votar por {{title}}",
  unvoteA11y: "Retirar tu voto por {{title}}",
  voteCount_one: "{{count}} voto",
  voteCount_many: "{{count}} votos",
  voteCount_other: "{{count}} votos",
  voteFailedTitle: "Tu voto no se ha guardado",
  voteFailedBody: "Comprueba tu conexión e inténtalo de nuevo.",
  status: {
    sent: "Enviada",
    under_review: "En revisión",
    planned: "Planificada",
    in_progress: "En desarrollo",
    shipped: "Ya en la app",
    not_planned: "No prevista por ahora",
  },
  ideaStatus: {
    considering: "En valoración",
    planned: "Planificada",
    in_progress: "En desarrollo",
    shipped: "Ya en la app",
  },
  category: {
    assets: "Activos y lugares",
    inspections: "Inspecciones y checklists",
    work: "Trabajos y órdenes",
    schedules: "Programaciones",
    reports: "Informes",
    team: "Equipo y contratistas",
    integrations: "Integraciones y API",
    other: "Otra cosa",
  },
  importance: {
    nice_to_have: "Estaría bien",
    saves_time: "Me ahorraría tiempo",
    blocking: "No puedo trabajar sin ella",
  },
  errors: {
    daily_limit: "Has enviado 5 solicitudes hoy. Envía el resto mañana.",
    workspace_limit: "Tu espacio de trabajo ha enviado 20 solicitudes hoy. Inténtalo de nuevo mañana.",
    blocked: "Las solicitudes de funciones están desactivadas para tu cuenta. Contacta con soporte si crees que es un error.",
    incomplete: "Añade un título corto y explica qué necesitas.",
    screenshot: "Una captura no se ha subido. Quítala o inténtalo de nuevo.",
    failed: "Tu solicitud no se ha enviado. Comprueba tu conexión e inténtalo de nuevo.",
  },
  form: {
    title: "Solicitar una función",
    subtitle: "Cuéntanos qué necesitas. El equipo de AssetWRX lee cada solicitud.",
    titleLabel: "¿Qué te gustaría?",
    titlePlaceholder: "Por ejemplo: imprimir una etiqueta QR para cada sala",
    titleRequired: "Añade un título corto.",
    descriptionLabel: "¿Cómo te ayudaría?",
    descriptionPlaceholder: "¿Qué intentas hacer y qué te lo impide hoy?",
    descriptionRequired: "Explica un poco qué necesitas.",
    categoryLabel: "¿Qué parte de la app?",
    categoryRequired: "Elige la parte de la app a la que se refiere.",
    importanceLabel: "¿Cuánto importa?",
    screenshotsLabel: "Capturas (opcional)",
    screenshotsHint: "Hasta 3. No incluyas datos personales ni de clientes.",
    addScreenshot: "Añadir una captura",
    addScreenshotShort: "Añadir",
    removeScreenshot: "Quitar captura",
    photoPermissionTitle: "Permitir acceso a las fotos",
    photoPermissionBody: "Para añadir una captura, permite que AssetWRX vea tus fotos en los Ajustes del teléfono.",
    similarTitle: "Ya pediste algo parecido",
    similarHint: "Si es lo mismo, puedes seguirla en Tus solicitudes en lugar de enviarla otra vez.",
    detailsTitle: "Se envía con tu solicitud",
    detailsHint: "Nos ayuda a entender dónde estabas. No se envía nada más de tu espacio de trabajo.",
    detailApp: "Versión de la app",
    detailUpdate: "Actualización",
    detailDevice: "Dispositivo",
    detailLanguage: "Idioma",
    detailScreen: "Pantalla",
    detailWorkspace: "Espacio de trabajo",
    detailWorkspaceValue: "El nombre y el plan de tu espacio de trabajo",
    send: "Enviar solicitud",
    failedTitle: "No enviada",
    sentTitle: "Gracias, la hemos recibido",
    sentBody: "Leemos cada solicitud. Recibirás una notificación cuando cambie su estado o te respondamos.",
    seeYourRequests: "Ver tus solicitudes",
    done: "Listo",
  },
},
};
